const CODE_KEY = '__weidun_code__'

export function getCode() {
    return sessionStorage.getItem(CODE_KEY)
}

export function setCode(code) {
    if (!code) return
    sessionStorage.setItem(CODE_KEY, code)
}

export function clearCode() {
    sessionStorage.removeItem(CODE_KEY)
}
